import * as React from 'react'
import g from 'glamorous'
import * as moment from 'moment'

import Navbar from '../components/Navbar'
import Headline from '../components/Headline'
import CreateLoanMutation from '../components/mutations/CreateLoanMutation'
import IsAdmin from '../components/IsAdmin'
import history from '../history'
import { loanQueries } from '../utils/refetchQueries'

import CreateLoanForm from './createLoan/CreateLoanForm'

export interface CreateLoanProps {}

const StyledContainer = g.div(({ theme }) => {
  return {
    maxWidth: '600px',
    width: '100%',
    margin: '0 auto'
  }
})

const CreateLoan: React.SFC<CreateLoanProps> = () => {
  return (
    <div>
      <Navbar />
      <StyledContainer>
        <Headline>Vytvořit půjčku</Headline>
        <IsAdmin>
          {isAdmin => (
            <CreateLoanMutation>
              {(createLoan, { data, called, error }) => (
                <CreateLoanForm
                  formError={error}
                  onSubmit={async ({
                    amount,
                    creditor,
                    debtors,
                    description,
                    interest,
                    interval,
                    startedOn
                  }) => {
                    const result = await createLoan({
                      variables: {
                        loan: {
                          amount: Number(amount),
                          creditor: creditor.value,
                          debtors: debtors.map(debtor => debtor.value),
                          description,
                          interest: Number(interest),
                          interval: interval ? interval.value : null,
                          startedOn: (startedOn ? startedOn : moment()).format(
                            'YYYY-MM-DD'
                          )
                        }
                      },
                      refetchQueries: loanQueries(isAdmin)
                    })

                    if (result == null || result.data == null) {
                      return
                    }

                    history.push('/')
                  }}
                />
              )}
            </CreateLoanMutation>
          )}
        </IsAdmin>
      </StyledContainer>
    </div>
  )
}

export default CreateLoan



// WEBPACK FOOTER //
// ./src/screens/CreateLoan.tsx